import { useLayoutEffect, useState } from "react";
import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import MultiSelectSimple from "../../../../../../../../../../components/dinamicForm/multiSelectSimple";
import { ConfirmModal } from "../../../../../main/components";
import { useTranslation } from "react-i18next";
import { useReassingModal } from "./styles";
import { useReportFoliosDetailContext } from "../../../../hooks/useReportFoliosContext";
import { Item, ObjectGeneric, onChangeEvent } from "../../../../../../../../../../utils/types/generals";
import { reportFolioServices } from "../../../../../../../../../../utils/constants/callService"
import { useParams } from "react-router-dom";
import { handleAllErrors } from "../../../../../../../../../../utils/methods/handleErrors"
import { Types } from "../../../../../../../../../../utils/enums"

interface ReassignModalProps {
  open: boolean;
  onClose: () => void;
  refresh: () => void;
}

export const ReassigAreaAndDepartmentModal = ({ open, onClose, refresh }: ReassignModalProps) => {
  const { t } = useTranslation();
  const { id } = useParams()
  const styles = useReassingModal();
  const { items, callReassignAreaAndDepartmentEndpoint, setSnackbar } = useReportFoliosDetailContext();

  const [selectedArea, setSelectedArea] = useState<ObjectGeneric | null>(null);
  const [selectedDepartment, setSelectedDepartment] = useState<ObjectGeneric | null>(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [filteredDepartments, setFilteredDepartments] = useState<Item[]>([]);

  const handleAreaChange = (e: onChangeEvent) => {
    const areaId = e.target.value;
    setSelectedArea(areaId);
    setSelectedDepartment(null);

    if (items.department) {
      const filtered = items.department.filter(
        (dept: Item) => dept.areaId === Number(areaId.value)
      );
      setFilteredDepartments(filtered);
    } else {
      setFilteredDepartments([]);
    }

  };

  const handleDepartmentChange = (e: onChangeEvent) => {
    setSelectedDepartment(e.target.value);
  };

  const handleSubmit = async () => {
    const body = {
      "areaId": selectedArea?.value,
      "departmentId": selectedDepartment?.value
    }

    const response = await reportFolioServices.reassignAreaAndDepartment({ body, id: id ?? "" })
    const code = response?.errors?.[0]?.code

    if (code) {
      setSnackbar({
        open: true,
        message: handleAllErrors(code, t, ''),
        type: Types.ERROR
      })
      return false
    }

    setSnackbar({
      open: true,
      message: t('reportFolio.detail.reassignAreaAndDepatmentReportFolio.message.edit'),
      type: Types.SUCCESS
    })
    setSelectedArea(null)
    setSelectedDepartment(null)
    return true
  }

  useLayoutEffect(() => {
    callReassignAreaAndDepartmentEndpoint();
  }, []);

  return (
    <>
      <Modal open={open} /* onClose={onClose} */ aria-labelledby="reassign-modal">
        <Box sx={styles.container}>
          <Typography variant="h6" component="h2" textAlign="center">
            {t('reportFolio.detail.general.reassignAreaAndDepartment')}
          </Typography>

          <Typography variant="body2" textAlign="center">
            {t('reportFolio.detail.general.selectAndConfirm')}
          </Typography>

          <Stack spacing={2} sx={{ mt: 2 }}>
            <MultiSelectSimple
              isRequired
              errors={null}
              name="areaId"
              label={t('reportFolio.detail.general.areaForm')}
              onChange={handleAreaChange}
              items={items.area}
              selected={selectedArea}
            />

            <MultiSelectSimple
              isRequired
              errors={null}
              name="departmentId"
              label={t('reportFolio.detail.general.deparmentFullForm')}
              onChange={handleDepartmentChange}
              items={filteredDepartments}
              selected={selectedDepartment}
              disabled={!selectedArea}
            />

            <Stack direction="row" spacing={2} justifyContent="space-between" mt={4}>
              <Button variant="text" color="primary" onClick={onClose}>
                {t('reportFolio.detail.general.cancel')}
              </Button>
              <Button
                variant="contained"
                onClick={() => setConfirmModalOpen(true)}
                disabled={!selectedArea || !selectedDepartment}
                sx={styles.button}
              >
                {t('reportFolio.detail.general.reassing')}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <ConfirmModal
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={async () => {
          const success = await handleSubmit();
          if (success) {
            refresh();
            onClose();
          }
        }}
        title="Confirmación"
        description={t('reportFolio.detail.general.reassignAreaAndDepartmentFolio')}
      />
    </>
  );
};